/**
 * Bad Studio Theme Scripts
 */

(function () {
  var body = document.body;

  /* ------------------------------------------------
     Nav Tray (slides up, single toggle)
     ------------------------------------------------ */
  var navToggle = document.getElementById('nav-toggle');
  var navTray = document.getElementById('nav-tray');
  var overlay = document.getElementById('tray-overlay');

  function closeAllTrays() {
    closeNav();
    closeContact();
    if (typeof closeCart === 'function') closeCart();
  }

  var topBarLogo = document.getElementById('top-bar-logo');

  function openNav() {
    closeContact();
    if (typeof closeCart === 'function') closeCart();
    if (topBarLogo) topBarLogo.classList.remove('top-bar-logo--hidden');
    navTray.classList.add('nav-tray--open');
    overlay.classList.add('tray-overlay--visible');
    body.classList.add('nav-open');
  }

  function closeNav() {
    navTray.classList.remove('nav-tray--open');
    overlay.classList.remove('tray-overlay--visible');
    body.classList.remove('nav-open');
    /* Re-apply scroll-hide if page is scrolled past threshold */
    if (topBarLogo && window.scrollY > 100) {
      topBarLogo.classList.add('top-bar-logo--hidden');
    }
  }

  function toggleNav() {
    if (body.classList.contains('nav-open')) {
      closeNav();
    } else {
      openNav();
    }
  }

  if (navToggle) navToggle.addEventListener('click', toggleNav);

  /* ------------------------------------------------
     Contact Tray (slides from right)
     ------------------------------------------------ */
  var contactToggle = document.getElementById('contact-toggle');
  var contactClose = document.getElementById('contact-close');
  var contactTray = document.getElementById('contact-tray');

  function openContact() {
    closeNav();
    if (typeof closeCart === 'function') closeCart();
    contactTray.classList.add('contact-tray--open');
    overlay.classList.add('tray-overlay--visible');
    body.classList.add('contact-open');
  }

  function closeContact() {
    contactTray.classList.remove('contact-tray--open');
    overlay.classList.remove('tray-overlay--visible');
    body.classList.remove('contact-open');
  }

  if (contactToggle) contactToggle.addEventListener('click', openContact);
  if (contactClose) contactClose.addEventListener('click', closeContact);

  /* ------------------------------------------------
     Cart Tray (slides from right)
     ------------------------------------------------ */
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = document.getElementById('cart-close');
  var cartTray = document.getElementById('cart-tray');

  function openCart() {
    closeNav();
    closeContact();
    cartTray.classList.add('contact-tray--open');
    overlay.classList.add('tray-overlay--visible');
    body.classList.add('cart-open');
  }

  function closeCart() {
    cartTray.classList.remove('contact-tray--open');
    overlay.classList.remove('tray-overlay--visible');
    body.classList.remove('cart-open');
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  /* Overlay closes whichever tray is open */
  if (overlay) {
    overlay.addEventListener('click', function () {
      closeNav();
      closeContact();
      closeCart();
    });
  }

  /* Escape key closes trays */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeNav();
      closeContact();
      closeCart();
    }
  });

  /* Close nav tray when a nav link is clicked */
  var navLinks = document.querySelectorAll('.nav-tray .nav-list a');
  navLinks.forEach(function (link) {
    link.addEventListener('click', closeNav);
  });

  /* ------------------------------------------------
     Logo scroll-hide: logo slides left on scroll,
     leaving just the arrow icon visible.
     ------------------------------------------------ */
  var scrollThreshold = 100;
  var lastScrollY = 0;

  if (topBarLogo) {
    window.addEventListener('scroll', function () {
      if (body.classList.contains('nav-open')) return;

      var currentScrollY = window.scrollY;
      var scrollingUp = currentScrollY < lastScrollY;

      // Show logo immediately when scrolling up, or when at top
      if (scrollingUp || currentScrollY <= scrollThreshold) {
        topBarLogo.classList.remove('top-bar-logo--hidden');
      } else if (currentScrollY > scrollThreshold) {
        topBarLogo.classList.add('top-bar-logo--hidden');
      }

      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  /* ------------------------------------------------
     Product Form: Option-level Variant Selection
     ------------------------------------------------ */
  var optionInputs = document.querySelectorAll('[data-option-input]');
  var priceEl = document.querySelector('[data-product-price]');
  var priceHeaderEl = document.querySelector('[data-product-price-header]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var productJsonEl = document.getElementById('product-json');

  if (optionInputs.length > 0 && productJsonEl) {
    var productData = JSON.parse(productJsonEl.textContent);

    function getSelectedOptions() {
      var selected = [];
      var optionCount = productData.options.length;
      for (var i = 0; i < optionCount; i++) {
        var checked = document.querySelector('[data-option-index="' + i + '"]:checked');
        selected.push(checked ? checked.value : null);
      }
      return selected;
    }

    function findVariant(selectedOptions) {
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateVariantUI() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);

      var isPreorder = document.body.querySelector('.preorder-notice') !== null;

      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (priceHeaderEl) priceHeaderEl.textContent = formatMoney(variant.price);

        /* Update hero image when variant has a featured image */
        var heroImg = document.getElementById('hero-product-image');
        if (heroImg && variant.featured_image && variant.featured_image.src) {
          heroImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
          if (variant.featured_image.alt) heroImg.alt = variant.featured_image.alt;
        }
        if (addToCartBtn) {
          if (isPreorder) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Pre-Order';
          } else if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold out';
          }
        }
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Unavailable';
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        /* Update active state within this option group */
        var groupName = this.name;
        var parentFieldset = this.closest('.product-form-option');

        /* Color swatches */
        if (parentFieldset) {
          parentFieldset.querySelectorAll('.color-swatch').forEach(function (s) {
            s.classList.remove('color-swatch--active');
          });
          parentFieldset.querySelectorAll('.pill-option').forEach(function (p) {
            p.classList.remove('pill-option--active');
          });
        }

        var parentLabel = this.closest('.color-swatch') || this.closest('.pill-option');
        if (parentLabel) {
          if (parentLabel.classList.contains('color-swatch')) {
            parentLabel.classList.add('color-swatch--active');
          } else {
            parentLabel.classList.add('pill-option--active');
          }
        }

        /* Update color name display */
        var colorNameEl = parentFieldset ? parentFieldset.querySelector('[data-color-name]') : null;
        if (colorNameEl) colorNameEl.textContent = this.value;

        /* Update size description display */
        var descriptionEl = parentFieldset ? parentFieldset.querySelector('[data-option-description]') : null;
        if (descriptionEl) {
          var valueLower = this.value.toLowerCase();
          if (valueLower === 'standard') {
            descriptionEl.textContent = 'Supports phones up to 6.3" (iPhone 16/17, Google Pixel 9, or similar)';
          } else if (valueLower === 'large') {
            descriptionEl.textContent = 'Supports phones up to 6.9" (iPhone 17 Pro Max, Samsung Galaxy S25 FE, or similar)';
          }
        }

        updateVariantUI();
      });
    });
  }

  /* ------------------------------------------------
     Customization Toggle
     ------------------------------------------------ */
  var customToggle = document.querySelector('[data-customization-toggle]');
  var customField = document.getElementById('customization-field');

  if (customToggle && customField) {
    customToggle.addEventListener('change', function () {
      customField.style.display = this.checked ? 'block' : 'none';
      if (!this.checked) {
        var textarea = customField.querySelector('textarea');
        if (textarea) textarea.value = '';
      }
    });
  }

  /* ------------------------------------------------
     AJAX Cart – helpers
     ------------------------------------------------ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    var countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = count;
  }

  /** Re-render the entire cart tray body from a cart JSON object */
  function renderCartTray(cart) {
    var body = document.getElementById('cart-tray-body');
    if (!body) return;

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-tray-empty" id="cart-tray-empty">your cart is empty</p>';
      return;
    }

    var itemsHtml = '<div class="cart-tray-items" id="cart-tray-items">';
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var imgTag = '';
      if (item.image) {
        var imgSrc = item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2');
        imgTag = '<a href="' + item.url + '" class="cart-tray-item-image">'
          + '<img src="' + imgSrc + '" alt="" width="60" height="60" loading="lazy">'
          + '</a>';
      }

      var variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<span class="cart-tray-item-variant">' + item.variant_title + '</span>';
      }

      itemsHtml += '<div class="cart-tray-item" data-line="' + line + '">'
        + imgTag
        + '<div class="cart-tray-item-info">'
        + '<a href="' + item.url + '" class="cart-tray-item-title">' + item.product_title + '</a>'
        + variantHtml
        + '<span class="cart-tray-item-price">' + formatMoney(item.final_line_price) + '</span>'
        + '<div class="cart-tray-item-qty">'
        + '<button type="button" class="cart-tray-qty-btn" data-tray-qty-minus="' + line + '" aria-label="Decrease quantity">&minus;</button>'
        + '<span class="cart-tray-qty-value" data-tray-qty-value="' + line + '">' + item.quantity + '</span>'
        + '<button type="button" class="cart-tray-qty-btn" data-tray-qty-plus="' + line + '" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '</div>'
        + '<button type="button" class="cart-tray-item-remove" data-tray-remove="' + line + '" aria-label="Remove ' + item.product_title + '">remove</button>'
        + '</div>';
    });
    itemsHtml += '</div>';

    var footerHtml = '<div class="contact-form-footer" id="cart-tray-footer">'
      + '<div class="cart-tray-subtotal"><span>subtotal</span>'
      + '<span id="cart-tray-subtotal">' + formatMoney(cart.total_price) + '</span></div>'
      + '<a href="/checkout" class="btn btn--full">checkout</a></div>';

    body.innerHTML = itemsHtml + footerHtml;
  }

  /** Fetch the latest cart and re-render tray */
  function refreshCartTray() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartTray(cart); });
  }

  /** Change a line item quantity via AJAX, then re-render */
  function changeLineQuantity(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCartTray(cart); });
  }

  /* ------------------------------------------------
     Product Form: Add to Cart via AJAX
     ------------------------------------------------ */
  var productForm = document.getElementById('product-form');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var checkedVariant = productForm.querySelector('input[name="id"]:checked')
        || productForm.querySelector('input[name="id"]');
      var qtyInput = productForm.querySelector('input[name="quantity"]');

      if (!checkedVariant) return;

      var variantId = checkedVariant.value;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var btn = productForm.querySelector('[data-add-to-cart]');

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        return refreshCartTray();
      })
      .then(function () {
        openCart();
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Add to cart';
        }
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Add to cart';
        }
      });
    });
  }

  /* ------------------------------------------------
     Cart Tray: quantity +/- and remove (delegated)
     ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    /* Quantity minus */
    var minusBtn = e.target.closest('[data-tray-qty-minus]');
    if (minusBtn) {
      var line = parseInt(minusBtn.getAttribute('data-tray-qty-minus'), 10);
      var valEl = document.querySelector('[data-tray-qty-value="' + line + '"]');
      var current = valEl ? parseInt(valEl.textContent, 10) : 1;
      changeLineQuantity(line, Math.max(0, current - 1));
      return;
    }

    /* Quantity plus */
    var plusBtn = e.target.closest('[data-tray-qty-plus]');
    if (plusBtn) {
      var line = parseInt(plusBtn.getAttribute('data-tray-qty-plus'), 10);
      var valEl = document.querySelector('[data-tray-qty-value="' + line + '"]');
      var current = valEl ? parseInt(valEl.textContent, 10) : 1;
      changeLineQuantity(line, Math.min(99, current + 1));
      return;
    }

    /* Remove item */
    var removeBtn = e.target.closest('[data-tray-remove]');
    if (removeBtn) {
      var line = parseInt(removeBtn.getAttribute('data-tray-remove'), 10);
      changeLineQuantity(line, 0);
      return;
    }
  });

  /* ------------------------------------------------
     Product Page: Quantity Controls (+/- on PDP only)
     ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;

    var container = btn.closest('.product-form-quantity-control');
    if (!container) return;
    var input = container.querySelector('.qty-input');
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    if (btn.hasAttribute('data-qty-minus')) {
      input.value = Math.max(min, val - 1);
    } else {
      input.value = Math.min(max, val + 1);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------
     Contact Type Buttons
     ------------------------------------------------ */
  var contactTypeHidden = document.getElementById('contact-type');
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.contact-type-option');
    if (!opt) return;
    document.querySelectorAll('.contact-type-option').forEach(function (b) {
      b.classList.remove('active');
    });
    opt.classList.add('active');
    if (contactTypeHidden) {
      contactTypeHidden.value = opt.getAttribute('data-type');
    }
  });

  /* ------------------------------------------------
     Rich text #contact* links → open contact tray
     Use #contact for no pre-selection, or
     #contact-{type} to pre-select a type, e.g.:
       #contact-file-downloads
       #contact-design-services
       #contact-product-feedback
       #contact-collaboration
       #contact-saying-hi
       #contact-other
     ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#contact"]');
    if (!link) return;
    e.preventDefault();
    if (typeof openContact === 'function') openContact();
    var href = link.getAttribute('href');
    var type = href === '#contact' ? null : href.replace('#contact-', '');
    if (type) {
      setTimeout(function () {
        var typeButton = document.querySelector('.contact-type-option[data-type="' + type + '"]');
        if (typeButton) typeButton.click();
      }, 100);
    }
  });

  /* ------------------------------------------------
     Contact CTA Buttons (with pre-selected type)
     ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var ctaBtn = e.target.closest('[data-contact-cta]');
    if (!ctaBtn) return;

    var ctaType = ctaBtn.getAttribute('data-cta-type');

    // Open contact tray
    if (typeof openContact === 'function') {
      openContact();
    }

    // Pre-select the contact type
    if (ctaType) {
      setTimeout(function () {
        var typeButton = document.querySelector('.contact-type-option[data-type="' + ctaType + '"]');
        if (typeButton) {
          typeButton.click();
        }
      }, 100);
    }
  });

  /* ------------------------------------------------
     Projects Feed Header Sticky Detection
     ------------------------------------------------ */
  var feedHeader = document.querySelector('.projects-feed-header');
  if (feedHeader) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 1) {
            feedHeader.classList.add('is-stuck');
          } else {
            feedHeader.classList.remove('is-stuck');
          }
        });
      },
      { threshold: [1], rootMargin: '-56px 0px 0px 0px' }
    );
    observer.observe(feedHeader);
  }

  /* ------------------------------------------------
     Projects Collection Filter Dropdown
     ------------------------------------------------ */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterDropdown = document.querySelector('[data-filter-dropdown]');
  var filterCurrent = document.querySelector('[data-filter-current]');
  var filterItems = document.querySelectorAll('.filter-dropdown-item');
  var projectCards = document.querySelectorAll('[data-project-card]');

  if (filterToggle && filterDropdown) {
    // Toggle dropdown
    filterToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = filterDropdown.style.display === 'block';
      filterDropdown.style.display = isOpen ? 'none' : 'block';
      filterToggle.setAttribute('aria-expanded', !isOpen);
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.projects-filter')) {
        filterDropdown.style.display = 'none';
        filterToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Handle filter selection
    filterItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var selectedCollection = this.getAttribute('data-collection');
        var selectedText = this.textContent;

        // Update current text
        if (filterCurrent) filterCurrent.textContent = selectedText;

        // Update active state
        filterItems.forEach(function (i) {
          i.classList.remove('filter-dropdown-item--active');
        });
        this.classList.add('filter-dropdown-item--active');

        // Filter project cards
        projectCards.forEach(function (card) {
          var cardCollection = card.getAttribute('data-collection');
          if (selectedCollection === 'all' || cardCollection === selectedCollection) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });

        // Close dropdown
        filterDropdown.style.display = 'none';
        filterToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ------------------------------------------------
     Hero Typewriter Effect
     ------------------------------------------------ */
  var typewriterEl = document.querySelector('[data-typewriter]');
  var heroPhrasesEl = document.getElementById('hero-phrases');

  if (typewriterEl && heroPhrasesEl) {
    // Fetch the JSON file with phrases
    var phrasesUrl = JSON.parse(heroPhrasesEl.textContent);

    fetch(phrasesUrl)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var phrases = data.phrases || [];
        if (phrases.length === 0) return;

        var currentPhraseIndex = 0;
        var currentCharIndex = 0;
        var isDeleting = false;
        var typingSpeed = 100;
        var deletingSpeed = 50;
        var pauseAfterComplete = 2000;
        var pauseAfterDelete = 500;

        function type() {
          var currentPhrase = phrases[currentPhraseIndex];

          if (isDeleting) {
            // Delete character
            typewriterEl.textContent = currentPhrase.substring(0, currentCharIndex - 1);
            currentCharIndex--;

            if (currentCharIndex === 0) {
              isDeleting = false;
              currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
              setTimeout(type, pauseAfterDelete);
              return;
            }
            setTimeout(type, deletingSpeed);
          } else {
            // Type character
            typewriterEl.textContent = currentPhrase.substring(0, currentCharIndex + 1);
            currentCharIndex++;

            if (currentCharIndex === currentPhrase.length) {
              isDeleting = true;
              setTimeout(type, pauseAfterComplete);
              return;
            }
            setTimeout(type, typingSpeed);
          }
        }

        // Start typing
        type();
      })
      .catch(function (error) {
        console.error('Error loading hero phrases:', error);
      });
  }

  /* formatMoney is declared in the AJAX Cart section above */

  /* ------------------------------------------------
     Helper: submit a form via hidden iframe so Shopify
     receives a real POST (passes bot-protection) while
     the page stays put.
     ------------------------------------------------ */
  function iframeSubmit(form, onSuccess) {
    var iframeName = 'hidden_frame_' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    var loadCount = 0;
    iframe.addEventListener('load', function () {
      /* First load is the blank iframe; second is the form response */
      loadCount++;
      if (loadCount < 2) return;
      onSuccess();
      setTimeout(function () {
        form.removeAttribute('target');
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 500);
    });

    form.target = iframeName;
    form.submit();
  }

  /* ------------------------------------------------
     Contact Form: Shopify native /contact submission
     ------------------------------------------------ */
  var contactForm = document.getElementById('contact-form');
  var contactSuccess = document.getElementById('contact-form-success');

  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = contactForm.querySelector('.contact-submit-btn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'sending…';
      }

      var newsletterCheckbox = document.getElementById('contact-newsletter');
      var wantsNewsletter = newsletterCheckbox && newsletterCheckbox.checked;
      var contactEmailInput = document.getElementById('contact-email-field');
      var ghostUrl = contactForm.getAttribute('data-ghost-url');

      iframeSubmit(contactForm, function () {
        /* If newsletter opted in and we have a Ghost URL + email, fire Ghost subscribe */
        if (wantsNewsletter && ghostUrl && contactEmailInput && contactEmailInput.value) {
          ghostSubscribe(ghostUrl, contactEmailInput.value, [], function () {
            /* Silently succeed or fail — contact submission already worked */
          });
        }

        contactForm.style.display = 'none';
        if (contactSuccess) contactSuccess.style.display = '';
      });
    });
  }

  /* ------------------------------------------------
     Footer Subscribe: Shopify native customer form
     ------------------------------------------------ */
  var footerForm = document.getElementById('footer-subscribe-form');
  var footerSuccess = document.getElementById('footer-subscribe-success');

  if (footerForm) {
    footerForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = footerForm.querySelector('.footer__subscribe-btn');
      if (btn) btn.disabled = true;

      iframeSubmit(footerForm, function () {
        footerForm.querySelector('.footer__subscribe-row').style.display = 'none';
        if (footerSuccess) footerSuccess.style.display = '';
      });
    });
  }

  /* ------------------------------------------------
     Phone Type Autocomplete (pre-order)
     ------------------------------------------------ */
  var phoneInput = document.getElementById('phone-type-input');
  var phoneHidden = document.getElementById('phone-type-value');
  var phoneList = document.getElementById('phone-type-list');

  if (phoneInput && phoneHidden && phoneList) {
    var phoneModels = [];
    var highlightIdx = -1;
    var jsonUrl = phoneList.getAttribute('data-phone-json');

    if (jsonUrl) {
      fetch(jsonUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) { phoneModels = data; });
    }

    function renderList(query) {
      var q = query.toLowerCase();
      var filtered = phoneModels.filter(function (p) {
        return p.model.toLowerCase().indexOf(q) > -1 || p.brand.toLowerCase().indexOf(q) > -1;
      });

      if (filtered.length === 0 || q === '') {
        phoneList.classList.remove('is-open');
        phoneList.innerHTML = '';
        highlightIdx = -1;
        return;
      }

      var html = '';
      var currentBrand = '';
      filtered.forEach(function (p, i) {
        if (p.brand !== currentBrand) {
          currentBrand = p.brand;
          html += '<div class="phone-type-group">' + p.brand + '</div>';
        }
        html += '<div class="phone-type-option" data-index="' + i + '" data-model="' + p.model + '">' + p.model + '</div>';
      });

      phoneList.innerHTML = html;
      phoneList.classList.add('is-open');
      highlightIdx = -1;
    }

    function selectPhone(model) {
      phoneInput.value = model;
      phoneHidden.value = model;
      phoneList.classList.remove('is-open');
      phoneList.innerHTML = '';
    }

    phoneInput.addEventListener('input', function () {
      phoneHidden.value = this.value;
      renderList(this.value);
    });

    phoneInput.addEventListener('focus', function () {
      if (this.value.length > 0) renderList(this.value);
    });

    phoneInput.addEventListener('keydown', function (e) {
      var options = phoneList.querySelectorAll('.phone-type-option');
      if (!options.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlightIdx = Math.min(highlightIdx + 1, options.length - 1);
        options.forEach(function (o) { o.classList.remove('is-highlighted'); });
        options[highlightIdx].classList.add('is-highlighted');
        options[highlightIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlightIdx = Math.max(highlightIdx - 1, 0);
        options.forEach(function (o) { o.classList.remove('is-highlighted'); });
        options[highlightIdx].classList.add('is-highlighted');
        options[highlightIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (highlightIdx >= 0 && options[highlightIdx]) {
          selectPhone(options[highlightIdx].getAttribute('data-model'));
        }
      } else if (e.key === 'Escape') {
        phoneList.classList.remove('is-open');
      }
    });

    phoneList.addEventListener('click', function (e) {
      var option = e.target.closest('.phone-type-option');
      if (option) selectPhone(option.getAttribute('data-model'));
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.phone-type-wrapper')) {
        phoneList.classList.remove('is-open');
      }
    });
  }

  /* ------------------------------------------------
     Ghost Member Subscribe
     Shared helper used by hero-split and WIP waitlist forms.
     Requires Ghost CORS to allow the Shopify storefront origin.
     ------------------------------------------------ */
  function ghostSubscribe(ghostUrl, email, labels, callback) {
    var payload = { email: email, emailType: 'subscribe' };
    if (labels && labels.length) {
      payload.labels = labels.map(function (l) { return { name: l }; });
    }
    fetch(ghostUrl.replace(/\/$/, '') + '/members/api/send-magic-link/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { callback(res.ok ? null : 'error'); })
      .catch(function () { callback('error'); });
  }

  /* Hero-split newsletter subscribe */
  document.querySelectorAll('[data-ghost-form]').forEach(function (form) {
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : 'subscribe';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ghostUrl = form.getAttribute('data-ghost-form');
      var email = form.querySelector('input[type="email"]').value;
      var msg = form.querySelector('[data-ghost-message]');

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'sending...'; }

      ghostSubscribe(ghostUrl, email, [], function (err) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        if (msg) {
          msg.removeAttribute('hidden');
          msg.classList.toggle('form-message--error', !!err);
          msg.textContent = err
            ? 'something went wrong — please try again.'
            : (form.getAttribute('data-success') || 'check your inbox for a magic link.');
        }
        if (!err) form.reset();
      });
    });
  });

  /* WIP product waitlist subscribe */
  document.querySelectorAll('[data-ghost-waitlist]').forEach(function (form) {
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : 'join waitlist';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ghostUrl = form.getAttribute('data-ghost-waitlist');
      var label = form.getAttribute('data-waitlist-label') || 'waitlist';
      var email = form.querySelector('input[type="email"]').value;
      var msg = form.querySelector('.waitlist-form__message');

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'joining...'; }

      ghostSubscribe(ghostUrl, email, [label], function (err) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        if (msg) {
          msg.removeAttribute('hidden');
          msg.classList.toggle('form-message--error', !!err);
          msg.textContent = err
            ? 'something went wrong — please try again.'
            : (form.getAttribute('data-success') || "you're on the list — we'll be in touch.");
        }
        if (!err) form.reset();
      });
    });
  });

})();
